/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Home_DescriptionInputs */



/**
* | output |
* | --- |
* | "Vessel inspections, quality assurance and marine consultancy from experienced master mariners and chief engineers, in ports around the world." |
*
* @param {Home_DescriptionInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
export const home_description = /** @type {((inputs?: Home_DescriptionInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Home_DescriptionInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "zh") return /** @type {LocalizedString} */ ("由经验丰富的船长和轮机长在全球各地港口提供船舶检查、质量保证和海事咨询服务。")
	return /** @type {LocalizedString} */ ("Vessel inspections, quality assurance and marine consultancy from experienced master mariners and chief engineers, in ports around the world.")
});